"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("date-fns");
const react_2 = require("react");
const pickers_1 = require("@material-ui/pickers");
const date_fns_1 = __importDefault(require("@date-io/date-fns"));
const fr_1 = __importDefault(require("date-fns/locale/fr"));
const ru_1 = __importDefault(require("date-fns/locale/ru"));
const en_US_1 = __importDefault(require("date-fns/locale/en-US"));
const localeMap = {
    en: en_US_1.default,
    fr: fr_1.default,
    ru: ru_1.default,
};
/**
 * A date picker control provide a simple way to select a date from calendar.
 **/
const DatePicker = (_a) => {
    var { placeholder = 'YYYY/MM/DD', locale = 'en', disabled = false, isDateDisabled, onChange, value, name, readOnly } = _a, props = __rest(_a, ["placeholder", "locale", "disabled", "isDateDisabled", "onChange", "value", "name", "readOnly"]);
    const [selectedDate, setSelectedDate] = react_2.useState(value || null);
    const handleDateChange = (date) => {
        setSelectedDate(date);
        onChange === null || onChange === void 0 ? void 0 : onChange(date);
    };
    return (react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default, locale: localeMap[locale] },
        react_1.default.createElement(pickers_1.KeyboardDatePicker, { id: props.controlId, PopoverProps: {
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
            }, variant: "inline", inputVariant: "outlined", disableToolbar: true, name: name, readOnly: readOnly, value: selectedDate, disabled: disabled, placeholder: placeholder, onChange: (date) => handleDateChange(date), format: "yyyy/MM/dd", shouldDisableDate: isDateDisabled, inputProps: {
                'aria-label': props.label,
                'aria-labelledby': props.ariaLabelledby,
                'aria-describedby': props.ariaDescribedby,
                'aria-required': props.ariaRequired,
            } })));
};
exports.default = DatePicker;
//# sourceMappingURL=index.js.map